export const getPlaceLatLng = (
  query: string,
  mapInstance: google.maps.Map
): Promise<google.maps.LatLngLiteral | undefined> => {
  if (mapInstance) {
    const placesService = new window.google.maps.places.PlacesService(mapInstance);

    return new Promise((resolve) =>
      placesService.findPlaceFromQuery({ query: query, fields: ['geometry.location'] }, (placeDetails, status) => {
        if (status != google.maps.places.PlacesServiceStatus.OK) {
          return;
        }
        if (placeDetails) {
          resolve(placeDetails[0].geometry?.location?.toJSON());
        }
      })
    );
  }

  return new Promise((resolve) => resolve(undefined));
};

export const INITIAL_ZOOM_LEVEL = 13;
export const DEFAULT_CENTER_COORDS = { lat: 33.9181012031489, lng: -118.35209230158749 };
